import { createSelector, createSlice } from '@reduxjs/toolkit';

import { BlogModel } from '@/models';
import { MenuItem, SlicePayload } from '@/types';
import { getBlogMenu } from '@/redux/epics/blog.epics';
import { RootState } from '../create-store';

export type BlogState = {
  blogResults: BlogModel | Record<string, never>;
  menu: MenuItem[] | [] | undefined;
}

export const initialState: BlogState = {
  blogResults: {},
  menu: undefined
};

const blog = createSlice({
  name: 'blog',
  initialState,
  reducers: {
    setBlogResults: (state, action: SlicePayload<{ blogResults: BlogModel }>) => {
      state.blogResults = action.payload.blogResults ?? {};
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getBlogMenu.fulfilled, (state, action) => {
      state.menu = action.payload.menuItems;
    });
    builder.addCase(getBlogMenu.rejected, (state, action) => {
      state.menu = action.payload as [];
    });
  }
});

export const {
  setBlogResults
} = blog.actions;

export default blog.reducer;

const selectBlogMenuState = (state: RootState) => state.blog;

export const selectBlogMenu = createSelector(
  [selectBlogMenuState],
  (blogState) => blogState.menu
);
